<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'Users overview' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="loading" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="above-table-container">
    <form [formGroup]="getSearchForm()" fxLayout="column" (ngSubmit)="submitRequest()">

      <div fxLayout="row" fxLayout.xs="column">
        <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
          <label class="control-label" for="status-filter">
            {{'Status' | translate}}
          </label>
          <div class="input-container" fxLayout="column" fxFlex>
            <ng-select
              labelForId="status-filter"
              [items]="getActiveStates()"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              (change)="onSelectStatus($event)"
              placeholder="{{'Please select...' | translate}}"
              notFoundText="{{'No results found' | translate}}"
              formControlName="status">
            </ng-select>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px" fxLayoutAlign="space-between center"
           fxLayoutAlign.xs="start stretch">
        <div fxLayoutAlign="start">
          <button class="btn btn-secondary btn-search" type="submit">
            <i class="fa fa-search fa-lg" aria-hidden="true"></i>
          </button>

          <div class="search input-container">
            <input
              class="form-control form-control-border"
              type="text"
              formControlName="searchTerm"
              autocomplete=off
              placeholder="{{'Search...' | translate}}">
            <i *ngIf="getSearchForm().controls.searchTerm.value && getSearchForm().controls.searchTerm.value.length"
               class="fa fa-times fa-lg" aria-hidden="true"
               (click)="clearInputField()"></i>
          </div>
        </div>

        <div class="above-table">
          <button (click)="goToNewUserPage()" class="btn btn-info add-btn" type="button">
            <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
            {{'Create new user' | translate}}
          </button>
        </div>
      </div>

    </form>
  </div>

  <div class="form-container-content">
    <div class="admin-users-list-container" fxHide.xs>
      <ul class="admin-users-list" fxLayout="column" fxHide.xs fxFlex>
        <li fxLayout fxFlex class="table-header">
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="15"
               [ngClass]="{'sorting': sortingObj.sortLastNameField.sorting === undefined, 'sorting_asc': sortingObj.sortLastNameField.sorting === true, 'sorting_desc': sortingObj.sortLastNameField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortLastNameField)" (keydown.enter)="sortTable(sortingObj.sortLastNameField)">
            <h4>{{'Last name' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="15"
               [ngClass]="{'sorting': sortingObj.sortFirstNameField.sorting === undefined, 'sorting_asc': sortingObj.sortFirstNameField.sorting === true, 'sorting_desc': sortingObj.sortFirstNameField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortFirstNameField)" (keydown.enter)="sortTable(sortingObj.sortFirstNameField)">
            <h4>{{'First name' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
               [ngClass]="{'sorting': sortingObj.sortStatusField.sorting === undefined, 'sorting_asc': sortingObj.sortStatusField.sorting === true, 'sorting_desc': sortingObj.sortStatusField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortStatusField)" (keydown.enter)="sortTable(sortingObj.sortStatusField)">
            <h4>{{'Status' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortCreationDateField.sorting === undefined, 'sorting_asc': sortingObj.sortCreationDateField.sorting === true, 'sorting_desc': sortingObj.sortCreationDateField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortCreationDateField)" (keydown.enter)="sortTable(sortingObj.sortCreationDateField)">
            <h4>{{'Creation date' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortLastLoginField.sorting === undefined, 'sorting_asc': sortingObj.sortLastLoginField.sorting === true, 'sorting_desc': sortingObj.sortLastLoginField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortLastLoginField)" (keydown.enter)="sortTable(sortingObj.sortLastLoginField)">
            <h4>{{'Last login' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
               [ngClass]="{'sorting': sortingObj.sortConfirmedField.sorting === undefined, 'sorting_asc': sortingObj.sortConfirmedField.sorting === true, 'sorting_desc': sortingObj.sortConfirmedField.sorting === false}"
               tabindex="0" (click)="sortTable(sortingObj.sortConfirmedField)" (keydown.enter)="sortTable(sortingObj.sortConfirmedField)">
            <h4>{{'User Confirmation' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="end center" fxFlex></div>
        </li>
        <li fxLayout class="table-items" *ngFor="let user of getListOfUsers()">
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
            <h5 class="table-item">{{user.lastName}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
            <h5 class="table-item">{{user.firstName}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
            <h5 class="table-item">{{(true === user.active ? 'active' : 'not-active') | translate }}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{user.creationDate | localizedDate}} {{user.creationDate | localizedDate:'shortTime'}}</h5>
          </div>
          <div class="last-login-time" fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{user.lastLogin | localizedDate}} {{user.lastLogin | localizedDate:'shortTime'}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
            <h5 class="table-item fas" [ngClass]="{'fa-check': user.confirmed === true, 'fa-times': user.confirmed === false }"></h5>
          </div>
          <div fxLayout fxLayoutAlign="end center" fxFlex class="buttons-container">
            <button (click)="goToEditPage(user)" class="btn btn-primary update-btn btn-icon" type="button">
              <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>

    <!--    Appears if device is a mobile phone -->
    <div class="table-mobile-layout" fxLayout="column" fxHide.gt-xs>
      <div *ngFor="let user of getListOfUsers(); let last = last;" fxLayout>
        <div fxLayout fxLayout="column" fxFlex="80">
          <div fxLayout>
            <label fxFlex="25">{{'Last name' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{user.lastName}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'First name' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{user.firstName}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Status' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{(true === user.active ? 'active' : 'not-active') | translate }}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Creation date' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{user.creationDate | localizedDate}} {{user.creationDate | localizedDate:'shortTime'}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Last login' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{user.lastLogin | localizedDate}} {{user.lastLogin | localizedDate:'shortTime'}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'User Confirmation' | translate}}: </label>
            <span fxFlex="5"></span>
            <!-- an i, not a span: the mobile layout sets the text font on every span, which would hide the icon -->
            <i class="fas" [ngClass]="{'fa-check': user.confirmed === true, 'fa-times': user.confirmed === false }"></i>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" class="mobileButtonsContainer">
          <button (click)="goToEditPage(user)" class="btn btn-primary update-btn btn-icon" type="button">
            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="divider"></div>
    </div>

  </div>

  <app-pagination
    [totalNumberOfItems]="getTotalNumberOfUsers()"
    [pageSize]="getItemsPerPage()"
    (pageSizeChange)="onPageSizeChange($event)"
    (pageChange)="onPageChange($event)">
  </app-pagination>

</div>
<div class="divider"></div>
